import { Link } from 'react-router-dom';
import type { VisitWithStore } from 'shared';
import { formatTimeCT } from '../utils/timezone';

interface Props {
  visits: VisitWithStore[];
}

export function ScheduleList({ visits }: Props) {
  // Group visits by date
  const groupedVisits = visits.reduce((acc, visit) => {
    const date = visit.start_datetime.split('T')[0];
    if (!acc[date]) acc[date] = [];
    acc[date].push(visit);
    return acc;
  }, {} as Record<string, VisitWithStore[]>);

  const sortedDates = Object.keys(groupedVisits).sort();

  if (visits.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '32px', color: '#6b7280' }}>
        No visits scheduled for this period.
      </div>
    );
  }

  const getVisitTypeStyle = (type: string) => {
    switch (type) {
      case 'training':
        return { backgroundColor: '#f3e8ff', color: '#7c3aed' };
      case 'post_market':
        return { backgroundColor: '#ffedd5', color: '#ea580c' };
      default:
        return { backgroundColor: '#dbeafe', color: '#2563eb' };
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {sortedDates.map((date) => (
        <div key={date} style={{ backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', backgroundColor: '#f9fafb', borderBottom: '1px solid #e5e7eb', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ fontWeight: 600, color: '#111827' }}>
              {new Date(date + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}
            </span>
            <Link to={`/route/${date}`} style={{ fontSize: '14px', color: '#2563eb', textDecoration: 'none' }}>
              View Route →
            </Link>
          </div>
          <div style={{ padding: '8px' }}>
            {groupedVisits[date]
              .sort((a, b) => a.start_datetime.localeCompare(b.start_datetime))
              .map((visit) => (
                <div key={visit.id} style={{ display: 'flex', alignItems: 'center', padding: '12px', borderBottom: '1px solid #f3f4f6' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, color: '#111827' }}>{visit.store.name}</div>
                    {visit.store.chain_name && (
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>{visit.store.chain_name}</div>
                    )}
                  </div>
                  <div style={{ textAlign: 'right', marginRight: '12px' }}>
                    <div style={{ fontSize: '14px', color: '#374151' }}>
                      {formatTimeCT(visit.start_datetime)}
                    </div>
                    <div style={{ fontSize: '12px', color: '#9ca3af' }}>{visit.duration_minutes} min</div>
                  </div>
                  {visit.hotel_recommended && (
                    <span title="Hotel recommended tonight" style={{ marginRight: '8px', fontSize: '16px' }}>🏨</span>
                  )}
                  <span style={{ ...getVisitTypeStyle(visit.visit_type), padding: '4px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500 }}>
                    {visit.visit_type}
                  </span>
                </div>
              ))}
          </div>
        </div>
      ))}
    </div>
  );
}
